import { ComponentRef } from '@angular/core';

import { NotificationsGroupComponent } from './notifications-group/notifications-group.component';

export class NotificationGroupRef<T = NotificationsGroupComponent> {
  public hostRef: ComponentRef<T>;
  public host: any;

  public token: string;

  constructor(groupToken: string) {
    this.token = groupToken;
  }
}
